'use client'
import React, { useEffect, useState } from "react";
//material ui imports
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, ImageList, ImageListItem } from "@mui/material";
//component imports
import EachProductCard from "./EachProductCard";
import NoItemsMessage from "./NoItemsMessage";
import { RoomModel } from '@/store/builderSlice';
import { designRoomTypeMap } from "./SubAccordion";
import BuilderSelect from "@/store/builderStoreSelector";
import { useDispatch } from "react-redux";
import axios from "axios";
import { BuilderProduct, Project } from "@/store/builderSlice";
import { apiStatusConstants } from "./SubAccordionDetails";
import { StaticImageData } from 'next/image';
import { imageMap } from "./ScannedImagesMap";
import { loadBuilderProductsByType } from "@/store/builder/thunks/builderProductsLoader";
import { actions as builderActions } from '@/store/builderSlice';
import LoadingSpinner from "./LoadingSpinner";
import { gtmClickTracking } from "@/utils";
import { v4 as uuidv4 } from 'uuid'
export interface MyStuffProps {
    isShowcaseFlow: boolean;
    isDesignShowcase: boolean;
    includeRecommendations: boolean;
    productId: any;
    productType: any;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}
const MyStuff: React.FC<MyStuffProps> = (props) => {
    console.log('mystuff component start-------------------')
    //props
    const { isShowcaseFlow, includeRecommendations, productId, productType, isDesignShowcase, handleCloseProductDetails, handleSelectedProductDetailId } = props
    //utility imports
    const dispatch = useDispatch()
    //state
    const [expanded, setExpanded] = useState<string | false>(() => {
        if (isShowcaseFlow && isDesignShowcase) return 'panel1';
        if (isShowcaseFlow) return 'panel2';
        return 'panel1';
    });
    const [apiStatus, setApiStatus] = useState<string>(apiStatusConstants.initial)
    const [currentAppiledDesign, setCurrentAppliedDesign] = useState<any>({})
    const [scannedImages, setScannedImages] = useState<{ img: StaticImageData }[]>([]);
    //store
    //inorder to get the room type we need currentRoomId roomModels currentRoomModel
    const currentRoomId: string = BuilderSelect.activeSelection().roomId;
    const roomModels: RoomModel[] = BuilderSelect.roomModels().models;
    const currentRoomModel = roomModels.find(roomModel => roomModel.roomId === currentRoomId);
    //roomtype, currentDesignId, currentStyle are required for getting the current applied design to the room
    const roomType: string = currentRoomModel ? (designRoomTypeMap[currentRoomModel.roomType] || currentRoomModel.roomType.toLowerCase()) : '';
    const currentDesignId: string = BuilderSelect.ui().designId;
    const currentStyle: string = BuilderSelect.ui().styleName;
    //products are in project
    const project: Project = BuilderSelect.project();
    const projectProducts: BuilderProduct[] = project.products;


    const urlParams: { [key: string]: string } = BuilderSelect.ui().urlParams;

    //effects
    useEffect(() => {
        dispatch(builderActions.addProductData({ products: projectProducts }))
    }, [projectProducts])
    useEffect(() => {
        //product flow
        if (isShowcaseFlow && (!isDesignShowcase)) {
            dispatch(loadBuilderProductsByType({ productId, productType, includeRecommendations }) as any)
        }
    }, [productId, productType, includeRecommendations, isShowcaseFlow, isDesignShowcase])

    useEffect(() => {
        //effect to fetch the design data
        const fetchDesignData = async () => {
            setApiStatus(apiStatusConstants.pending)
            try {
                const response: any = await axios.get(`https://nestingale.com/v2/api/designs?designId=${currentDesignId}`)
                if (response.data) {
                    const designData = response.data.designs[0];
                    if (designData?.isPersonalizable) {
                        setCurrentAppliedDesign(designData)
                        dispatch(builderActions.addProductData({ products: designData.products.filter((eachProduct: any) => eachProduct.model3dUrl) }))
                        setApiStatus(apiStatusConstants.fulfilled)
                    } else {
                        throw new Error('design is not personalizable');
                    }
                } else {
                    throw new Error('error at my stuff component while fetch current applied design');
                }
            } catch (error) {
                console.log(error, 'error at my stuff component while fetch current applied design')
                setApiStatus(apiStatusConstants.rejected)
            }

        }
        if (currentDesignId && expanded === 'panel1' && !(isShowcaseFlow && !isDesignShowcase)) {
            fetchDesignData()
        }
    }, [currentDesignId, expanded, isShowcaseFlow, isDesignShowcase]);
    //for scanned items
    const storedArray = localStorage.getItem(`scannedItems1_${urlParams.projectId}`);
    const scannedItems = storedArray ? JSON.parse(storedArray) : [];

    useEffect(() => {
        // effect for scanned products
        const reloadImages = () => {
            const storedArray = localStorage.getItem(`scannedItems1_${urlParams.projectId}`);
            const scannedItems = storedArray ? JSON.parse(storedArray) : [];

            // Map item names to images
            const updatedImages = scannedItems
                .map((item: string) => ({ img: imageMap[item] || imageMap["DefaultTable"] })) // Fallback to DefaultTable if not found
                .filter((item: { img: any; }) => item.img); // Filter out undefined values

            setScannedImages(updatedImages);
        };

        reloadImages(); // Load images on mount

        // Optional: Add event listener for storage updates
        window.addEventListener("storage", reloadImages);

        return () => {
            window.removeEventListener("storage", reloadImages);
        };
    }, []);
    //handlers
    const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
        if (panel === 'panel1') {
            gtmClickTracking({ event: 'selected_design' })
        }
        if (panel === 'panel2') {
            gtmClickTracking({ event: 'selected_products' })
        }
        if (panel === 'panel3') {
            gtmClickTracking({ event: 'scanned_items' })
        }
    };
    function getUi() {
        const getFulfilledUi = () => {
            return (
                <>
                    {Object.keys(currentAppiledDesign).length > 0 ? <AccordionDetails>
                        <Box component="div">
                            <img src={currentAppiledDesign.designImage} alt='design' style={{ width: '100%', height: '130px', borderRadius: '10px' }} />
                            <Typography sx={{ color: '#000', fontWeight: '800', margin: '2px 8px', textAlign: 'center' }}>{currentAppiledDesign.designName}</Typography>
                            <Typography sx={{ margin: '2px 8px', textAlign: 'center', fontSize: '12px' }}>Products in this design</Typography>
                        </Box>
                        {
                            currentAppiledDesign.products.filter((eachProduct: any) => eachProduct.model3dUrl).sort((a: any, b: any) => {
                                return a.availability?.toLowerCase() === "available" && b.availability?.toLowerCase() !== "available" ? -1 : 1;
                            }).map((eachProduct: any) => {
                                return (
                                    <EachProductCard key={eachProduct.productId} eachProduct={eachProduct} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />
                                )
                            })
                        }
                    </AccordionDetails> : <NoItemsMessage textToShow="No design applied" />}</>
            )
        }
        // root return jsx for getUi function
        switch (apiStatus) {
            case apiStatusConstants.pending:
                return <LoadingSpinner />
            case apiStatusConstants.fulfilled:
                return getFulfilledUi()
            case apiStatusConstants.rejected:
                return <NoItemsMessage textToShow="No design applied" />
            default:
                return null
        }
    }
    // root return jsx
    return (
        <>
            <div className="custom_inner_accordion">
                {!(isShowcaseFlow && !isDesignShowcase) && <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
                    <AccordionSummary expandIcon={expanded === 'panel1' ? <KeyboardArrowUpIcon sx={{ fontSize: '18px', color: '#000' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: '18px', color: '#000' }} />}>
                        <Typography>Design: <Box component="span" sx={{ color: '#25282B' }}>Applied to {isShowcaseFlow ? 'Room' : 'project'}</Box></Typography>
                    </AccordionSummary>
                    {getUi()}
                </Accordion>}
                <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
                    <AccordionSummary expandIcon={expanded === 'panel2' ? <KeyboardArrowUpIcon sx={{ fontSize: '18px', color: '#000' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: '18px', color: '#000' }} />}>
                        <Typography>Product(s): {projectProducts.length > 0 ? 'Applied to room' : 'None applied'}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {
                            projectProducts.length > 0 ?
                                projectProducts.map((eachProduct: BuilderProduct, index: number) => {
                                    return (
                                        <EachProductCard key={index + eachProduct.productId} eachProduct={eachProduct} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />)
                                }) : <NoItemsMessage />
                        }
                    </AccordionDetails>
                </Accordion>
                {!isShowcaseFlow && <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
                    <AccordionSummary expandIcon={expanded === 'panel3' ? <KeyboardArrowUpIcon sx={{ fontSize: '18px', color: '#000' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: '18px', color: '#000' }} />}>
                        <Typography>Scanned</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box component="div" sx={{ background: '#C4C4C4', borderRadius: '5px', padding: '2px 10px 0 10px' }}>
                            <ImageList cols={1} rowHeight={164}>
                                {scannedImages.length > 0 ? scannedImages.map((item) => (
                                    <ImageListItem key={uuidv4()} sx={{ maxWidth: '100%' }}>
                                        <img
                                            src={`${item.img.src}`}
                                            alt='scanned-image'
                                            style={{ maxWidth: '100%', objectFit: 'none' }}
                                        />
                                    </ImageListItem>
                                )) : <NoItemsMessage textToShow="No scanned items" />}
                            </ImageList>
                        </Box>
                    </AccordionDetails>
                </Accordion>}
                {expanded && <div className="accordion_shades"></div>}
            </div>

        </>
    );
};

export default MyStuff;